import type { PdfPreviewRendererProps } from '@liscio/common';
import { Box, PdfDocumentViewer } from '@liscio/ui';

import { reportPdfViewerError } from './reportPdfViewerError';

/**
 * Read-only rendering for requests, uploads and signed-URL documents. There is
 * nowhere to save a rotation, so the viewer shows no rotation controls.
 */
export function FirmPdfPreview({
  url,
  title = 'Document.pdf',
  width,
  height = '70vh',
  maxHeight,
  initialFit,
  onLoadError,
}: PdfPreviewRendererProps & { onLoadError?: (url: string) => void }) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: width ?? '100%',
        height,
        maxHeight,
        minHeight: 0,
      }}
    >
      <PdfDocumentViewer
        documentId={url}
        url={url}
        title={title}
        initialFit={initialFit}
        onLoadError={onLoadError}
        onError={reportPdfViewerError}
      />
    </Box>
  );
}
